import { useTranslation } from "react-i18next";
import IFolderAttributesProps from "./IFolderAttributesProps";
import { useState } from "react";
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, Table, TableBody, TableCell, TableCellLayout, TableRow, Tooltip } from "@fluentui/react-components";
import { Info16Regular } from "@fluentui/react-icons";
import IAttribute from "../../models/IAttribute";

export default function FolderAttributes(props: IFolderAttributesProps) {
    const { t } = useTranslation();

    const [open, setOpen] = useState(false);
    
    return (
        <Dialog open={open} onOpenChange={(_, data) => setOpen(data.open)}>
            <DialogTrigger disableButtonEnhancement>
                <Tooltip content={t("attributes.title")} relationship="label">
                    <Button icon={<Info16Regular />} />
                </Tooltip>
            </DialogTrigger>
            <DialogSurface>
                <DialogTitle>
                    {t("attributes.title")}
                </DialogTitle>
                <DialogBody>
                    <DialogContent>
                        <Table>
                            <TableBody>
                                {
                                    props.folder.attributes
                                        .map((attribute: IAttribute, index: number) => (
                                            <TableRow key={index}>
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {attribute.name}
                                                    </TableCellLayout>
                                                </TableCell>
                                                <TableCell>
                                                    <TableCellLayout>
                                                        {attribute.value}
                                                    </TableCellLayout>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                }
                            </TableBody>
                        </Table>
                    </DialogContent>
                    <DialogActions>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="secondary">
                                {t("general.close")}
                            </Button>
                        </DialogTrigger>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
}